import { FC, SVGProps } from 'react';

import ChatIcon from 'assets/icons/chat.svg';
import ChainsIcon from 'assets/icons/nav/chains.svg';
import CommunitySignalIcon from 'assets/icons/nav/community-signal.svg';
import CopyTradingIcon from 'assets/icons/nav/copy-trading.svg';
import NftIcon from 'assets/icons/nav/nft.svg';
import PortfolioIcon from 'assets/icons/nav/portfolio.svg';
import SwapIcon from 'assets/icons/nav/swap.svg';
import WhitepaperIcon from 'assets/icons/nav/whitepaper.svg';
import WorldIcon from 'assets/icons/nav/world.svg';
import DiscordIcon from 'assets/icons/socials/discord.svg';
import TelegramIcon from 'assets/icons/socials/telegram2.svg';
import XIcon from 'assets/icons/socials/x.svg';

// ── Types ───────────────────────────────────────────────────────────────────

export interface CommunitySubItem {
  id: string;
  label: string;
  icon: FC<SVGProps<SVGSVGElement>>;
  href: string;
}

export interface MenuItem {
  id: string;
  icon: FC<SVGProps<SVGSVGElement>>;
  label: string;
  color: string;
  glowColor: string;
  subItems?: CommunitySubItem[];
  inactive?: boolean;
}

// ── Menu Items ──────────────────────────────────────────────────────────────

export const MENU_ITEMS = [
  {
    id: 'swap',
    icon: <SwapIcon />,
    label: 'Swap',
    color: '#00ccaa',
    glowColor: 'rgba(0, 204, 170, 0.7)',
  },
  {
    id: 'copy',
    icon: <CopyTradingIcon />,
    label: 'Copy-Trade',
    color: '#ffaa00',
    glowColor: 'rgba(255, 170, 0, 0.7)',
  },
  {
    id: 'portfolio',
    icon: <PortfolioIcon />,
    label: 'Portfolio',
    color: '#aa66ff',
    glowColor: 'rgba(170, 102, 255, 0.7)',
  },
  {
    id: 'nft',
    icon: <NftIcon />,
    label: 'NFT Modules',
    color: '#0099ff',
    glowColor: 'rgba(0, 153, 255, 0.7)',
  },
  {
    id: 'vision',
    icon: <WhitepaperIcon />,
    label: 'Whitepaper',
    color: '#ffcc00',
    glowColor: 'rgba(255, 204, 0, 0.7)',
  },
  {
    id: 'community',
    icon: <CommunitySignalIcon />,
    label: 'Community',
    color: '#a33cc8',
    glowColor: 'rgba(160, 60, 200, 0.7)',
    inactive: true,
    subItems: [
      {
        id: 'telegram',
        label: 'Telegram',
        icon: <TelegramIcon />,
        href: 'https://t.me/wowmaxexchange',
      },
      {
        id: 'x',
        label: 'X',
        icon: <XIcon />,
        href: 'https://x.com/WowmaxExchange',
      },
      {
        id: 'discord',
        label: 'Discord',
        icon: <DiscordIcon />,
        href: 'https://discord.gg/wowmax',
      },
    ],
  },
  {
    id: 'sophie',
    icon: <ChatIcon />,
    label: 'Sophie',
    color: '#00ff78',
    glowColor: 'rgba(0, 255, 120, 0.7)',
  },
  {
    id: 'chains',
    icon: <ChainsIcon />,
    label: 'Chains',
    color: '#ff8833',
    glowColor: 'rgba(255, 136, 51, 0.7)',
  },
];

// ── Layout Constants ────────────────────────────────────────────────────────
// Ring radius & extend: % of ItemsLayer square container = min(100vw, 100vh)
// Item/SubItem sizes: px (fixed on desktop, clamp on mobile)

export const RING_RADIUS_DESKTOP = 30;
export const RING_RADIUS_MOBILE = 30;

export const ITEM_SIZE_DESKTOP = 70;
export const ITEM_SIZE_MOBILE = 58;

export const SUB_ITEM_SIZE_DESKTOP = 46;
export const SUB_ITEM_SIZE_MOBILE = 42;

export const COMMUNITY_EXTEND_DESKTOP = 12;
export const COMMUNITY_EXTEND_MOBILE = 12;

export const MENU_BTN_SIZE_DESKTOP = 58;
export const MENU_BTN_SIZE_MOBILE = 52;
export const MENU_BTN_MARGIN = 20;

export const START_DEGREE = 300;

export const ITEM_STAGGER_MS = 60;
